import { safeGetAttributeInfo } from '../../../../Model/avenyModelUtils';
import { IAvenyModelContext } from '../../../../Model/ModelContext/ModelContext';
import { IColumnDef } from '../../../../Types/ColumnDefType';

/**
 * Sätter column caption om det inte redan finns på en column
 */
export const getColumnWithCaption = (
  collectionName: string,
  modelContext: IAvenyModelContext,
  column: IColumnDef
): IColumnDef => {
  if (!column.caption) {
    const attrDisplayLabel = safeGetAttributeInfo(
      collectionName,
      column.attributeDef,
      modelContext.avenyCollectionMap
    )
      .map(info => info.attribute.DisplayLabel)
      .unwrapOr('displaylabel saknas');

    return { ...column, caption: attrDisplayLabel };
  } else {
    return column;
  }
};
